import { Component, OnInit, ViewChild, OnDestroy, AfterContentChecked } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material";
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { Subject, Subscription, EMPTY } from 'rxjs';

import { SnackbarService } from "../shared/services/snackbar.service";
import { ExpiredQuotesCommunicationService } from "./recent-expired-quotes.service";
import { SessionStorageService } from "../shared/services/session-storage.service";
import { SharedService } from "../shared/services/shared.service";
import { TooltipService } from "../shared/services/tooltip.service";
import { RestrictOutsideScrollService } from "../shared/services/restrict-outside-scroll.service";

import { PaginationComponent } from "../shared/components/pagination/pagination.component";

import { config } from "../../../config/index";

@Component({
    template: require('./recent-expired-quotes.component.html'),
    styles: [require('./recent-expired-quotes.component.less')],
    providers: [ExpiredQuotesCommunicationService, MatDialog, SnackbarService, TooltipService],
    preserveWhitespaces: true
})


export class RecentExpiredQuotesComponent implements OnInit, OnDestroy, AfterContentChecked {

    @ViewChild("paginationId", { static: false }) setPagination: PaginationComponent;
    @ViewChild('previewMailBody', { static: false }) previewMailBody: any;
    @ViewChild('assignBulkRefPatientDialog', { static: false }) assignBulkRefPatientDialog: any;
    @ViewChild('reviveConfirmationDialog', { static: false }) reviveConfirmationDialog: any;
    @ViewChild('pendingTreatmentwarningPopup', { static: false }) pendingTreatmentwarningPopup: any;
    @ViewChild('addTreatmentwarningPopup', { static: false }) addTreatmentwarningPopup: any;


    private followUpRedData: any[] = [];
    private followUpYellowData: any[] = [];
    private followUpGreenData: any[] = [];
    expiredQuotesListData: any[];
    followUpListCompleteData: any[] = [];
    filteredItems: any[];
    data: any = {};
    locationList: any[] = [];
    allTCList: any[] = [];
    startCount: number;
    expiredQuotesTotalCount: number;
    endCount: number;
    master: number;
    selectedType: any;
    paginationItems: any;
    locatManager: string;
    filterExpn: any = {};
    cooAdmin: string;
    private _title: string;
    private _role = config.role;
    private _userRole: string;
    reqItemsPerPage: number;
    reqPageOffset: number = 0;
    searchValue: string = '';
    loading: boolean = true;
    patientId: any = null;
    colWidth: any = 14;
    TCList: any[] = [];
    tcIdValue: any;
    notificationFlag: boolean = false;
    sortParam: string;
    sortParams: any = ['first_name', 'responsible_party', 'health_id', 'tc_name', 'location', 'group', 'expired_at', 'communication_count'];
    sortParamsConfig: any = [];
    order: string;
    BulkAssign: any = {};
    BulkAssignRequest: any = [];
    bulkAssignTCClass: any = 'selector';
    bulkAssignLocationClass: any = 'selector';
    isInnerSidebarOpen: boolean = true;
    reviveData: any;
    reviveIndex: any;
    selectAll: boolean = false;
    changeTcSubmit: boolean = false;
    isShowAll: boolean;
    showText: string = 'SHOW_ALL';
    isToggleShowAll: boolean;
    showAllToggleClicked: boolean = false;
    isTouchDevice: boolean;
    dialogNewClasses: string;
    isFirstLocFilter: boolean = true;
    isFirstTCFilter: boolean = true;
    pendingTreatmentApprovalExist: boolean = false;
    expiredQuoteData: any;
    enableBufferPopup: boolean = false;
    bufferExist: boolean = false;
    formattedApproveDate: any = new Date();
    captcha: string = '';
    captcha_required: boolean = false;
    patientFileData: any;

    limitInputSub$: Subject<string> = new Subject<string>();
    inputSubscription: Subscription;
    searchInputSub$: Subject<string> = new Subject<string>();
    searchSubscription: Subscription;
    apiSubscription: Subscription[] = [];
    tcAndLocationSubscription: Subscription[] = [];
    followupFilterApiSubscription: Subscription;

    constructor(
        private _expiredQuotesFilterService: ExpiredQuotesCommunicationService,
        private _router: Router,
        private _sessionStorageService: SessionStorageService,
        private _sharedService: SharedService,
        public dialog: MatDialog,
        private _activatedRoute: ActivatedRoute,
        private _mdlSnackbarService: SnackbarService,
        private _restrictOutsideScrollService: RestrictOutsideScrollService,
        private _tooltipService: TooltipService

    ) {
    }

    goToPatientFile(list: any, scrollToTreatmentPlans: boolean = false) {
        if (list.patient_file_id) {
            let viewData = JSON.parse(JSON.stringify(list));
            viewData.id = list.patient_file_id;
            this.viewPatient(viewData, scrollToTreatmentPlans);
        }
    }

    viewPatient = (data: any, scrollToTreatmentPlans: boolean = false) => {
        this._sessionStorageService.saveItem('viewPatientId', data);
        if (scrollToTreatmentPlans) {
            this._router.navigate(['patient/patient-file-view'], { queryParams: { scrollToTreatmentPlans: true } });
        } else {
            this._router.navigate(['patient/patient-file-view']);
        }
    };

    // for sorting
    sort(param: any) {
        this.sortParam = param;
        if (this.sortParamsConfig[param].firstToggle) {
            this.sortParamsConfig[param].firstToggle = false;
        }
        else {
            this.sortParamsConfig[param].sortDescending = !this.sortParamsConfig[param].sortDescending;
        }
        for (let i = 0; i < this.sortParams.length; i++) {
            if (this.sortParams[i] !== param) {
                this.sortParamsConfig[this.sortParams[i]].firstToggle = true;
            }
        }
        this.sortParamsConfig[param].sortDescending ? this.order = 'des' : this.order = 'asc';
        this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
    }

    customerList = (search: any, pageItems: any, offset: any, fromToggle?: boolean) => {
        this.loading = true;
        this.followupFilterApiSubscription?.unsubscribe();
        let itemLimit = this.isToggleShowAll ? null : pageItems;
        this.followupFilterApiSubscription = this._expiredQuotesFilterService.expiredQuotesFilterService(this.filterExpn, search, itemLimit, offset, this.patientId, this.sortParam, this.order)
            .subscribe(res => this.expiredQuotesSuccessHandler(res, fromToggle),
                error => {
                    if (fromToggle || (!fromToggle && this.showAllToggleClicked)) {
                        this.showAllToggleClicked = false;
                        this.isToggleShowAll = !this.isToggleShowAll;
                    }
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
    };

    /** Fetching user role **/
    userRoleFetch = () => {
        this._sessionStorageService.readItem(this._role).then((data: any) => {
            this._userRole = data.role;
            this.tcAndLocationSubscription.forEach((subscription) => {
                subscription?.unsubscribe();
            });
            this.getLocations();
            if (this._userRole === 'TC') {
                this.colWidth = 13;
            } else {
                this.tcList();
            }
        });
    };

    private getTimeZoneDate(date: Date, timeZone?: string): Date {
        if (!timeZone) {
            return date;
        }
        const zonedDateTime = new Intl.DateTimeFormat('sv-SE', {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        }).format(date).replace(' ', 'T');
        return new Date(zonedDateTime);
    }

    isQuoteOverNinetyOneDays(quote: any): boolean {
        if (!quote?.expires_at) {
            return false;
        }

        const timeZone = quote?.time_zone || quote?.location?.time_zone || quote?.location?.city?.time_zone;
        const now = this.getTimeZoneDate(new Date(), 'UTC');
        const expiresAt = this.getTimeZoneDate(new Date(quote.expires_at), timeZone);

        if (isNaN(expiresAt.getTime())) {
            return false;
        }

        // Normalize to date only (strip time component)
        const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const expiresAtDateOnly = new Date(expiresAt.getFullYear(), expiresAt.getMonth(), expiresAt.getDate());

        const millisecondsInDay = 24 * 60 * 60 * 1000;
        const daysSinceExpiry = Math.floor((nowDateOnly.getTime() - expiresAtDateOnly.getTime()) / millisecondsInDay) + 1;
        return daysSinceExpiry > 91;
    }

    goToTreatmentPlan(expiredQuotesData: any, actionType: string = 'edit') {
        this.apiSubscription.push(this._sharedService.getTreatmentPlan(expiredQuotesData.id)
            .subscribe((res: any) => {
                const patientFile = res.data.patient_file;
                this._sessionStorageService.saveItem('editPrevPlan', true);
                const viewPatientData = {
                    ...patientFile,                                                        // spread all patient_file fields
                    id: patientFile.id,
                    age: new Date().getFullYear() - new Date(patientFile.patient.dob).getFullYear(),
                    doctor_id: patientFile.doctor?.id || null,
                    location_id: patientFile.location?.id || null,
                    tc_id: patientFile.tc?.id || null,
                    patient_file_id: patientFile.id,
                    init_treatment_pref_id: patientFile.init_treatment_pref
                        ? patientFile.init_treatment_pref.id
                        : null,
                };
                this._sessionStorageService.saveItem("viewPatientId", viewPatientData);
                this._sessionStorageService.saveItem('historyActionType', actionType);
                this._sessionStorageService.saveItem('currentTreatmentPlan', {
                    id: res.data.id,
                    plan_status: res.data.plan_status,
                    additional_tx_plan_data: {
                        referring_doctor: patientFile.referring_doctor,
                        relationship: patientFile.responsible_parties[0]?.relationship
                    }
                }).then(
                    () => {
                        this.loading = false;
                        this._router.navigate(['patient/treatment-plan']);
                    });
            },
                () => {
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                }));
    }


    cloneExpiredQuote(expiredQuotesData: any) {
        this.loading = true;
        this.expiredQuoteData = expiredQuotesData;
        this.patientFileData = expiredQuotesData;
        this.fetchActivePatientFileTxPlanStatus(expiredQuotesData);
    }

    addTreatmentwarningPopupClose() {
        this.loading = false;
        this.addTreatmentwarningPopup.close();
    }

    //buffer period checking
    bufferCheck(latestTxPlan: any) {
        const today: any = new Date();
        let txDuration: number;
        let buffDuration: number = 0;
        if(latestTxPlan.approved_at) {
            let appDate: any = new Date(latestTxPlan.approved_at);
            let currBuffDuration = Math.floor(today - appDate)/ (1000 * 60 * 60 * 24);
            if (buffDuration===0 || currBuffDuration<buffDuration) {
                buffDuration = currBuffDuration;
            }
        }
        let approveDate: any = new Date(latestTxPlan.approved_at);
        let bufferDuration = Math.floor(today - approveDate)/ (1000 * 60 * 60 * 24);
        txDuration = latestTxPlan.treatment_time*30; // tx plan duration in days

        this.enableBufferPopup = latestTxPlan.group?.name!=="Phase 1";
        this.bufferExist = (bufferDuration < ((18 * 30) + txDuration)); // 18 month tx duration check
        this.formattedApproveDate = ("0" + (approveDate.getMonth() + 1)).slice(-2) + '/' + ("0" + approveDate.getDate()).slice(-2) + '/' + ("0" + approveDate.getFullYear()).slice(-4);
    }

    validateCaptcha() {
        this.captcha_required = true;
        if (this.captcha === 'ADDITIONAL') {
            this.addTreatmentwarningPopupClose();
            this.goToTreatmentPlan(this.expiredQuoteData, 'clone');
        } else {
            this._mdlSnackbarService.showSnackbar('WRONG_CAPTCHA', 'error');
        }
    }

    fetchActivePatientFileTxPlanStatus(expiredQuotesData: any) {
        this._expiredQuotesFilterService.fetchActivePatientFileTxPlanStatus(expiredQuotesData.patient_file_id)
            .subscribe(res => this.fetchActivePatientFileTxPlanStatusSuccessHandler(res, expiredQuotesData),
                error => this.fetchActivePatientFileTxPlanStatusErrorHandler(error));
    }

    fetchActivePatientFileTxPlanStatusErrorHandler(error: any) {
        this.loading = false;
        if (error.error_code === 316) {
            this.pendingTreatmentApprovalExist = false;
            this.pendingTreatmentwarningPopup.show();
        } else if (error.error_code === 340) {
            this.pendingTreatmentApprovalExist = true;
            this.pendingTreatmentwarningPopup.show();
        } else {
            this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
        }

    }

    fetchActivePatientFileTxPlanStatusSuccessHandler(response: any, expiredQuotesData: any) {
        if (response.data?.latest_tx_plankey) {
            this.bufferCheck(response.data?.latest_tx_plankey);
        }
        if (this.bufferExist && this.enableBufferPopup) {
            this.captcha = '';
            this.captcha_required = false;
            this.addTreatmentwarningPopup.show();
        } else {
            this.goToTreatmentPlan(expiredQuotesData, 'clone');
        }
    }

    /** Fetching user role **/
    revive = (expiredQuotesData: any, index: any) => {
        this.loading = true;
        this.apiSubscription.push(this._expiredQuotesFilterService.reviveService(expiredQuotesData.id)
            .subscribe((res: any) => {
                this.expiredQuotesListData.splice(index, 1);
                this._mdlSnackbarService.showSnackbar('TREATMENT_PLAN_REVIVED', 'success');
                this.cancelReviveConfirmation();
                this.goToTreatmentPlan(expiredQuotesData, this._userRole === 'TC' ? 'edit' : 'view');
            },
                (error: any) => {
                    this.loading = false;
                    this.cancelReviveConfirmation();
                    if(error.error_code === 316){
                        this.pendingTreatmentApprovalExist = false;
                        this.pendingTreatmentwarningPopup.show();
                    } else if (error.error_code === 340) {
                        this.pendingTreatmentApprovalExist = true;
                        this.pendingTreatmentwarningPopup.show();
                    } else {
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    }
                }));
    };

    reviveConfirmation() {
        this.revive(this.reviveData, this.reviveIndex);
    }

    showReviveConfirmationPopup(expiredQuotesData: any, index: any) {
        this.reviveData = expiredQuotesData;
        this.patientFileData = expiredQuotesData;
        this.reviveIndex = index;
        this.reviveConfirmationDialog.show();
    }

    cancelReviveConfirmation() {
        this.reviveData = '';
        this.reviveIndex = '';
        this.reviveConfirmationDialog.close();
    }

    /**Sort list data based on days_over_due value **/
    overDueSort = (data: any[]) => {
        data.forEach((patient) => {
            patient.idName = 'phone' + patient.patient.id;
            if (patient.days_over_due > 0) {
                this.followUpRedData.push(patient);
                patient.className = "status-colorR";
            }
            else if (patient.days_over_due == 0) {
                this.followUpYellowData.push(patient);
                patient.className = "status-colorY";
            }
            else if (patient.days_over_due < 0) {
                this.followUpGreenData.push(patient);
                patient.className = "status-colorG";
            }
            patient.backgroundClassName = "backgroundW";

            if (patient.opt_in_status === 'accepted') {
                patient.phoneClassName = "material-icons icon phone-icon-green";
            }
            else if (patient.opt_in_status === 'rejected') {
                patient.phoneClassName = "material-icons icon phone-icon-red";
            }
            else {
                patient.phoneClassName = "material-icons icon phone-icon-grey";
            }
        });
    };

    /**
    * Function for Folow Up List Success CallBack
    * @param  {any} response contains response from success CallBack
    */
    expiredQuotesSuccessHandler = (response: any, fromToggle?: boolean) => {
        if (fromToggle) {
            this.setLimit(this.reqItemsPerPage, '', true);
        }

        if (fromToggle || (!fromToggle && this.showAllToggleClicked)) {
            this.isShowAll = !this.isShowAll;
            this.showText = (this.isShowAll) ? 'SHOW_LESS' : 'SHOW_ALL';
            this.showAllToggleClicked = false;
            if (!this.isShowAll) {
                this.clearBulkAssign();
                this.BulkAssignRequest = [];
            }
        }
        this.setResponseData(response.data, fromToggle);
        this.selectAll = false;
        this.expiredQuotesTotalCount = response.count;
        if (this.reqPageOffset >= 0) {
            if (this.expiredQuotesListData.length !== 0) {
                this.startCount = this.reqPageOffset + 1;
                this.endCount = this.startCount + this.expiredQuotesListData.length - 1;
            } else {
                this.startCount = 0;
                this.endCount = 0;
            }
        }
        this.loading = false;
        return;
    };

    setResponseData(data: any, fromToggle?: boolean) {
        if (!data) {
            this.expiredQuotesListData = [];
            this.followUpListCompleteData = [];
        } else {
            this.expiredQuotesListData = data;
            this.followUpListCompleteData = data;
            this.expiredQuotesListData.forEach((listData) => {
                listData.showHistory = false;
                listData.historyDataList = [];
                if (fromToggle && this.isShowAll && this.BulkAssign.treatment_plans.indexOf(listData.id) !== -1) {
                    listData.selected = true;
                }
            });
        }
    }

    /**
    * Function to set items Per page value
    * @param  {any} limitValue
    * @param  {any} event
    */
    setLimit(limitValue: any, event: any, fromToggle?: boolean) {
        if (limitValue !== null) {
            this.master = limitValue;
            this.setPagination.changedValue = true;
            this.setPagination.itemsPerPage = this.master;
            this.paginationItems = this.setPagination.emitterEvent();
            this.reqItemsPerPage = this.paginationItems.passedItems;
            this.reqPageOffset = this.paginationItems.reqOffset;
            if (!fromToggle) {
                this.clearBulkAssign();
                this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
            }
        }
    }

    /**
     * Function to set maximum items to be displayed in a page
     * @param  {any} selectedPageNumber
     */
    maxItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber < this.expiredQuotesTotalCount) {
            this.selectedType = selectedPageNumber + 1;
            this.setLimit(this.selectedType, event);
        }
    }

    /**
     * Function to capture event emitted from pagination component
     * @param  {any} event
     */
    paginationComponentEvent(event: any) {
        if (event.isClicked) {
            this.clearBulkAssign();
            this.customerList(this.searchValue, event.itemsPerPage, event.offset);
        }
        this.reqItemsPerPage = event.itemsPerPage;
        this.reqPageOffset = event.offset;
    }

    /**
     * Function to set minimum no of items to be displayed in apage
     * @param  {any} selectedPageNumber
     */
    minItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber > 1) {
            this.selectedType = selectedPageNumber - 1;
            this.setLimit(this.selectedType, event);
        }
    }

    formatAMPM(dateString: any) {
        let date = new Date(dateString);
        let hours = date.getHours();
        let minutes: any = date.getMinutes();
        let ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        let strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    searchItem(value: any) {
        this.reqPageOffset = 0;
        this.customerList(value, this.reqItemsPerPage, this.reqPageOffset);

    }

    clearBulkAssign() {
        this.BulkAssign.treatment_plans = [];
        this.BulkAssign.locations = [];
        this.BulkAssign.plan_locations = [];
    }

    initiate() {
        this._title = "Follow-Up Communications";
        this.selectedType = 10;
        this.userRoleFetch();
        this.customerList('', 10, 0);
        this.clearBulkAssign();
        this.locatManager = config.location_manager;
        this.cooAdmin = config.coo_admin;
        for (let i = 0; i < this.sortParams.length; i++) {
            let newConfig = {
                sortDescending: true,
                firstToggle: true
            };
            this.sortParamsConfig[this.sortParams[i]] = newConfig;
        }
    }

    resetPageOffset() {
        this.reqPageOffset = 0;
    }

    filterChange(parameter: any, value: any) {
        this.loading = true;
        this.resetPageOffset();
        if (this.searchValue === undefined)
            this.searchValue = '';
        if (this.reqItemsPerPage === undefined)
            this.reqItemsPerPage = 10;
        let itemLimit = this.isToggleShowAll ? null : this.reqItemsPerPage;
        if (parameter === 'location') {
            if (this.isFirstLocFilter) {
                this.isFirstLocFilter = false;
            } else {
                if (value === undefined) {
                    this.filterExpn.location = undefined;
                    this.filterExpn.tc = undefined;
                    this.tcIdValue = undefined;
                    this.TCList = this.allTCList;
                    this.followupFilterApiSubscription?.unsubscribe();
                    this.followupFilterApiSubscription = this._expiredQuotesFilterService.expiredQuotesFilterService(this.filterExpn, this.searchValue, itemLimit, this.reqPageOffset, this.patientId, this.sortParam, this.order)
                        .subscribe(res => this.expiredQuotesSuccessHandler(res),
                            error => {
                                this.loading = false;
                                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                            });
                } else {
                    this.setLocations(value,itemLimit);
                }
            }
        } else {
            this.setFilter(value, itemLimit);
        }
    }

    setLocations(value: any,itemLimit: any) {
        this.locationList.forEach((location) => {
            if (location.id === value) {
                this.TCList = location.tc_list;
                if (this.tcIdValue){
                    this.isFirstTCFilter = true;
                }
                this.tcIdValue = undefined;
                this.filterExpn.location = value;
                this.filterExpn.tc = undefined;
                this.followupFilterApiSubscription?.unsubscribe();
                this.followupFilterApiSubscription = this._expiredQuotesFilterService.expiredQuotesFilterService(this.filterExpn, this.searchValue, itemLimit, this.reqPageOffset, this.patientId, this.sortParam, this.order)
                    .subscribe(res => this.expiredQuotesSuccessHandler(res),
                        error => {
                            this.loading = false;
                            this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                        });

                return true;
            }
        });
    }

    setFilter(value: any, itemLimit: any) {
        if (this.isFirstTCFilter) {
            this.isFirstTCFilter = false;
        } else {
            if (value === undefined) {
                this.filterExpn.tc = undefined;
            }
            else {
                this.filterExpn.tc = value;
            }
            this.followupFilterApiSubscription?.unsubscribe();
            this.followupFilterApiSubscription = this._expiredQuotesFilterService.expiredQuotesFilterService(this.filterExpn, this.searchValue, itemLimit, this.reqPageOffset, this.patientId, this.sortParam, this.order)
                .subscribe(res => this.expiredQuotesSuccessHandler(res),
                    error => {
                        this.loading = false;
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    });
        }
    }

    getLocations() {
        let req_filter = true;
        if (this._userRole === 'TC') {
            this.tcAndLocationSubscription.push(this._expiredQuotesFilterService.getLocationList(req_filter)
                .subscribe((res: any) => {
                    this.locationList = res.data;
                },
                    error => console.log(error)));
        } else {
            this.tcAndLocationSubscription.push(this._expiredQuotesFilterService.getLocationList()
                .subscribe((res: any) => {
                    this.locationList = res.data;
                },
                    error => console.log(error)));
        }
    }

    tcList() {
        this.tcAndLocationSubscription.push(this._expiredQuotesFilterService.getTCList()
            .subscribe((res: any) => {
                this.allTCList = res.data;
                this.TCList = res.data;
            },
                error => console.log(error)));
    }

    isAssignUserSameLocation(user: any, location_id: number) {
        let status;
        if (user.locations) {
            status = user.locations.find((location: any) => location.id === location_id);
        }
        return status ? true : false;
    }

    checkEvenTCForOtherLocations(tc: any, location_id: number) {
        let availableTCs = this.allTCList.filter((tc: any) => !this.isAssignUserSameLocation(tc, location_id));
        let index = availableTCs.indexOf(tc);
        return index%2 ? true : false;
    }

    /**
    * Function for setting Bulk Assign Object
    */
     setBulkAssignRequestObj() {
        this.BulkAssignRequest = [];
        let selectedLocations = new Set(this.BulkAssign.locations);
        selectedLocations.forEach((location_id: any) => {
            let location_name = this.BulkAssign.plan_locations.find((plan_locations: any) => plan_locations.location_id === location_id).location_name;
            let location_plans = this.BulkAssign.plan_locations.reduce((plans: any, plan_locations: any) => {
                if (plan_locations.location_id === location_id) {
                   plans.push(plan_locations.plan_id);
                }
                return plans;
              }, []);
            if (location_plans.length) {
                this.BulkAssignRequest.push({location_id: location_id, treatment_plan_ids: location_plans, location_name: location_name, confirmTransfer: true});
            }
        });
    }

    /**
    * Function for selecting a patient
    */
    selectPatient(plan: any, index: number) {
        event.stopPropagation();
        if (this.expiredQuotesListData[index].selected) {
            this.BulkAssign.treatment_plans.push(plan.id);
            this.BulkAssign.plan_locations.push({location_id: plan.location.id, plan_id: plan.id, location_name: plan.location.city.name});
            this.BulkAssign.locations.push(plan.location.id);
            if (this.BulkAssign.treatment_plans.length === this.expiredQuotesListData.length) {
                this.selectAll = true;
            }
        }
        else {
            this.selectAll = false;
            let ind = this.BulkAssign.treatment_plans.indexOf(plan.id);
            if (index > -1) {
                this.BulkAssign.treatment_plans.splice(ind, 1);
                this.BulkAssign.plan_locations.splice(ind, 1);
                this.BulkAssign.locations.splice(ind, 1);
            }
        }
        this.setBulkAssignRequestObj();
    }

    /**
    * function for select all patients
    */
    selectAllpatients() {
        event.stopPropagation();
        this.clearBulkAssign();
        var that = this;
        this.expiredQuotesListData.forEach(function (plan) {
            plan.selected = that.selectAll;
            that.BulkAssign.treatment_plans.push(plan.id);
            that.BulkAssign.plan_locations.push({location_id: plan.location.id, plan_id: plan.id, location_name: plan.location.city.name});
            that.BulkAssign.locations.push(plan.location.id);
        });
        if (!this.selectAll) {
            this.clearBulkAssign();
        }
        this.setBulkAssignRequestObj();
    }

    /**
    * Open bulk assign model
    */

     bulkAssign() {
        this.changeTcSubmit = false;
        this.assignBulkRefPatientDialog.show();
    }

    /**
    * Close bulk assign model
    */

    assignBulkDialogClose() {
        this.BulkAssignRequest.forEach((plan_location: any) => {
            if (plan_location.tc_id) {
                delete plan_location.tc_id;
            }
            plan_location.confirmTransfer = true;
        });
        this.assignBulkRefPatientDialog.close();
    }

    /**
    * Function for assign bulk
    */

    assignBulkTC() {
        this.changeTcSubmit = true;
        let reqData: any = [];
        let validRequest: boolean = true;
        this.BulkAssignRequest.forEach((plan_location: any) => {
            if (plan_location.confirmTransfer) {
                reqData.push(plan_location);
                if (!plan_location.tc_id) {
                    validRequest = false;
                }
            }
        });
        if (validRequest) {
            this.apiSubscription.push(this._expiredQuotesFilterService.assignBulkTCUpdate(reqData)
                .subscribe((res: any) => {
                    this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
                    this.BulkAssign = {};
                    this.clearBulkAssign();
                    this.BulkAssignRequest = [];
                    this.selectAll = false;
                    this._mdlSnackbarService.showSnackbar('TC_ASSIGN_SUCCESS', 'success');
                    this.assignBulkRefPatientDialog.close();
                }, (error: any) => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                }));
        } else {
            this._mdlSnackbarService.showSnackbar('FILL_REQUIRED_DETAILS', 'error');
        }
    }

    toggleShowAll() {
        this.showAllToggleClicked = true;
        this.isToggleShowAll = !this.isToggleShowAll;
        this.reqItemsPerPage = (this.isToggleShowAll) ? null : this.selectedType;
        this.reqPageOffset = 0;
        this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset, true);
    }

    ngOnInit() {
        this._activatedRoute.params.subscribe(params => {
            this.patientId = params['id'];
            if (this.notificationFlag) {
                this.initiate();
            }
            this.notificationFlag = true;
        });

        // add delay for setting pagination limit on typing
        this.inputSubscription = this.limitInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.setLimit(this.selectedType, event);
                return EMPTY;
            })
        ).subscribe();

        // add delay for search on typing
        this.searchSubscription = this.searchInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(() => {
                this.searchItem(this.searchValue);
                return EMPTY;
            })
        ).subscribe();

        this.initiate();
    }

    ngAfterContentChecked() {
        this.isTouchDevice = ("ontouchstart" in document.documentElement);
        if (this.isTouchDevice) {
            this.dialogNewClasses = 'new-dialog-container';
        } else {
            this.dialogNewClasses = 'new-dialog-container desktop-view';
        }
    }

    ngOnDestroy() {
        this.reviveConfirmationDialog.close();
        this.assignBulkRefPatientDialog.close();
        this.pendingTreatmentwarningPopup.close();

        //Unsubscribing all the subscription
        this.inputSubscription?.unsubscribe();
        this.searchSubscription?.unsubscribe();
        this.followupFilterApiSubscription?.unsubscribe();
        this.tcAndLocationSubscription.forEach((subscription) => {
            subscription?.unsubscribe();
        })
        this.apiSubscription.forEach((subscription) => {
            subscription?.unsubscribe();
        })
    }
}
